/**
 * created by panjm on 2020-04-28
 *
 * description：消息中心模块接口地址配置
 *
 */

const config = require('libs/config.js')

const message = {
	// 消息列表
	getList: config.MS_XY_PATH + '/outline/message/record/records',
	// 删除消息
	del: config.MS_XY_PATH + '/outline/message/record/delete',
	// 标记为已读
	read: config.MS_XY_PATH + '/outline/message/record/read',
	// 全部标记为已读
	allRead: config.MS_XY_PATH + '/outline/message/record/read/all',
	// 获取tab数量
	getNum: config.MS_XY_PATH + '/outline/message/record/noReadCount'
}

export default message



// WEBPACK FOOTER //
// ./src/api/message/index.js